import { QueryFunction } from 'react-query';
import { apiFactory } from '../ApiFactory';
import { IContent } from './interfaces/contentInterface';

type IGetBySlug = [string, { slug: string }];
type IGetOrderBump = [string, { uuid: string }];
type IGetById = [string, { id: number }];

const getBySlug: QueryFunction<IContent, IGetBySlug> = async ({ queryKey }) => {
	const [_, { slug }] = queryKey;

	const response = await (
		await apiFactory.getInstance().getCurseducaClasClient()
	).get<IContent>(`/contents/slug/${slug}`);

	return response.data;
};

/**
 * Conteúdo por uuid — usado pelo bloco de order bump do builder (o uuid vem
 * do seletor de produtos do painel). Null quando não existe/sem acesso.
 */
const getByUuid: QueryFunction<IContent | null, IGetOrderBump> = async ({
	queryKey
}) => {
	const [_, { uuid }] = queryKey;

	const client = await apiFactory.getInstance().getCurseducaClasClient();

	try {
		const { data } = await client.get<IContent>(
			`${process.env.REACT_APP_CURSEDUCA_CLAS_DOMAIN}/contents/uuid/${uuid}`
		);
		return data;
	} catch {
		return null;
	}
};

/**
 * Conteúdo por id — vitrine da oferta de upsell/downsell (título, imagem,
 * preço de tabela). O valor COBRADO vem do pay (`/payments/upsell/preview`);
 * este é o que aparece enquanto ele carrega e no preview do builder.
 */
const getById: QueryFunction<IContent | null, IGetById> = async ({
	queryKey
}) => {
	const [_, { id }] = queryKey;
	const client = await apiFactory.getInstance().getCurseducaClasClient();
	const { data } = await client.get<IContent>(`/contents/${id}`);
	return data ?? null;
};

const getOrderBump: QueryFunction<IContent | null, IGetOrderBump> = async ({
	queryKey
}) => {
	const [_, { uuid }] = queryKey;

	const client = await apiFactory.getInstance().getCurseducaClasClient();

	const { data } = await client.get<IContent>(
		`${process.env.REACT_APP_CURSEDUCA_CLAS_DOMAIN}/order-bump/${uuid}`
	);

	return data;
};

export const contentsApi = {
	getBySlug: {
		key: 'GET_CONTENT_BY_SLUG',
		fetch: getBySlug
	},
	getById: {
		key: 'GET_CONTENT_BY_ID',
		fetch: getById
	},
	getByUuid: {
		key: 'GET_CONTENT_BY_UUID',
		fetch: getByUuid
	},
	getOrderBump: {
		key: 'GET_RDER_BUMP',
		fetch: getOrderBump
	}
};
